import React, { useState, useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import useTranslation from '../../../../i18n/useTranslation.js'
import { Collapse } from 'reactstrap'
import useGetEducatorLink from '../GetEducatorLink'
import RenderLocationInputs from './RenderLocationInput'
import { Field, LabeledField, PlainTextInput, InputSelect } from '@Knowledge-OTP/znk-ui-components'
import { escapeRegExp } from 'lodash'
const LessonDetails = (props) => {
  /** LESSON DETAILS QUE SE MUESTRA EN MAKEUP LESSON**/
  const { form, setForm, typeAndlocation, isEdit } = props
  const services = useSelector((state) => state.user.services) || []
  const selectedServiceTopics = useMemo(() => {
    const selectedServiceId = form?.service?.id
    if (!selectedServiceId) return []
    return services.find(service => service.id === selectedServiceId)?.topics ?? []
  //eslint-disable-next-line
  }, [services, form?.service?.id])
  const { translate } = useTranslation()
  const separateCamelCase = (str) => {
    if (str) str = str.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) { return str.toUpperCase() })
    return str
  }
  // ✅ Función para manejar cambio de topic
  const handleTopicChange = (topicId) => {
    const selectedTopic = selectedServiceTopics.find(top => top.id === topicId)
    
    if (selectedTopic) {
      setForm({
        ...form,
        educatorRate: null,
        educator: null,
        topic: { id: topicId, name: selectedTopic.name },
        title: `${form?.service?.name || ''} ${selectedTopic.name}`.trim()
      })
    }
  }
  const [isOpenCollapse, setOpenCollapse] = useState(false)
  // ✅ Memoizar opciones de topics
  const topicOptions = useMemo(() => {
    return selectedServiceTopics.map((top) => ({
      value: top.id,
      label: top.name
    }))
  }, [selectedServiceTopics])
  const [educatorLink, setEducatorLink] = useState(null)
  //get educator link for zoom location
  const [getEducatorLink] = useGetEducatorLink(
    (res) => {
      const link = res.user.educatorInfo?.backupLink
      setEducatorLink(link)
    },
    console.error
  )
  useEffect(() => {
    getEducatorLink({
      variables: {
        id: form?.educator?.educatorUserId
      }
    })
    //eslint-disable-next-line
  }, [form?.educator?.educatorUserId])

  return (
    <div className="d-flex flex-column">
      <span className="h4 font-weight-bold my-2">
        {translate(
          form?.isMeeting
            ? "modal.newlesson.meetingdetails"
            : form?.service?.name === "Orientation"
              ? "modal.newlesson.orientationdetails"
              : "modal.newlesson.lessondetails"
        )}
      </span>
      <span className="h4 my-2">
        {form?.isMeeting && form?.title
          ? form?.title
          : `${form?.service?.name || "No defined"}, ${form?.topic?.name ||
          "No defined"}`}
      </span>
      <span className="h45 text-gray my-2 pr-2">
        {separateCamelCase(typeAndlocation)}
      </span>
      {isEdit ? (
        <>
          <label
            className="btn-link"
            onClick={() => {
              setOpenCollapse(!isOpenCollapse);
            }}
          >
            {translate(
              form?.isMeeting
                ? "modal.editlesson.editMeetingdetails"
                : form?.service?.name === "Orientation"
                  ? "modal.editlesson.editOrientationdetails"
                  : "modal.editlesson.editdetails"
            )}
          </label>
          <Collapse isOpen={isOpenCollapse} className="w-100">
            <RenderLocationInputs {...{ setForm, form, educatorLink }} />
            <div className="d-flex flex-column justify-content-between">
              <label className='col-12 text-muted mt-2 mb-2 mt-3 pl-0'>
                {translate('modal.newlesson.topic')}
              </label>
              <Field
                InputClassName='col-12 p-0'
                type={InputSelect}
                filterOption={(obj, string) => {
                  if (new RegExp(escapeRegExp(string), 'i').test(obj.name)) return true
                  return false
                }}
                fieldName='topic'
                placeholder={translate('modal.newlesson.selecttopic')}
                value={form?.topic?.id}
                options={topicOptions}
                onChange={handleTopicChange}
                // disabled={!selectedService} // ✅ Deshabilitar si no hay servicio seleccionado
              />
              <label className='col-12 text-muted mt-2 mb-2 mt-3 pl-0'>
                {translate('modal.editLesson.title')}
              </label>
              <Field
                type={LabeledField}
                component={PlainTextInput}
                fieldName='lessonTitle'
                placeholder='Lesson Title'
                style={{
                  borderTopRightRadius: 0,
                  borderBottomRightRadius: 0,
                }}
                labelContainerClassName="mb-0"
                value={form?.title}
                onChange={(e) => {
                  setForm({ ...form, title: e });
                }}
              />
            </div>
          </Collapse>
        </>
      ) : (
        <RenderLocationInputs {...{ setForm, form, educatorLink }} />
      )}
    </div>
  );
}

export default LessonDetails
